import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    NavController, IonLabel, IonNote, IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { MarvTagComponent } from '@marv/components';
import { MarvDateService } from '@marv/services';
import { EpochToStringPipe } from '@app/pipes';
import { PlanningItem, RetailerLogoComponent } from '@app/components';
import { MissionTypeService } from '@app/services';

@Component({
    selector: 'app-planning-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        IonLabel, IonNote, IonIcon, TranslatePipe, EpochToStringPipe, forwardRef(() => MarvTagComponent), forwardRef(() => RetailerLogoComponent)
    ]
})
export class PlanningItemComponent  implements OnInit {

    @Input({alias : 'planningItem', required : true}) planningItem: PlanningItem;
    @Input({alias : 'displayReport', required : false}) displayReport: boolean = true;
    @Output() onSelectPlanningItem = new EventEmitter<PlanningItem>();

    constructor(
        private navController: NavController,
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {}
    
    selectPlanningItem(){
        this.onSelectPlanningItem.emit(this.planningItem);
    }
    
    goToPermanentPlanning(event: any){
        event.stopPropagation();
        let date = MarvDateService.ToDate(this.planningItem.day);
        if(date){
            let week = moment(MarvDateService.GetFirstDayOfWeek(date)).format('YYYY-MM-DD');
            this.navController.navigateRoot('permanent-planning', {
                queryParams: {
                    operationId: this.planningItem.operation.id, 
                    agentId: this.planningItem.salesRep?.id,
                    week: week
                }
            });
        }
    }
}
